class n {
  isNumberNumeric(r) {
    return !Number.isNaN(r) && Number.isFinite(r);
  }
  isNumeric(r) {
    if (r == null)
      return !1;
    const t = r.toString().trim() ?? "", i = parseFloat(t);
    return this.isNumberNumeric(i);
  }
  /**
   * Accepts a number or numeric string and formats a number
   * to the desired precision. If the precision is less
   * than the number of decimal places, otherwise the
   * number is returned.
   *
   * If a precision is not provided,
   * or it is null, an integer value will be returned.
   *
   * If the number/numberString is not a valid number
   * 0 will be returned
   *
   * @param number
   * @param precision
   */
  formatDynamicDecimal(r, t, i = !1) {
    if (r == null)
      return "0";
    const e = r.toString().trim();
    return this.isNumeric(e) ? t ? e.indexOf(".") === -1 ? parseInt(e) + (i ? ".0" : "") : e.split(".")[1].length < t ? parseFloat(e).toString() : parseFloat(e).toFixed(t) : parseInt(e).toString() : "0";
  }
  formatPercent(r, t = !1, i = 2) {
    if (r == null)
      return "";
    let e = parseFloat(r.toString().trim());
    return this.isNumberNumeric(e) ? (t && (e *= 100), `${e.toFixed(i)}%`) : "";
  }
  parseNumber(r, t, i) {
    return r == null || !this.isNumeric(r) ? t : i(r.toString().trim());
  }
  parseInt(r, t = 0) {
    return this.parseNumber(r, t, parseInt);
  }
  parseFloat(r, t = 0) {
    return this.parseNumber(r, t, parseFloat);
  }
}
const a = new n();
export {
  a as default
};
